import React from "react";
import * as helpers from "../../../shared/lib/helpers";

interface ItemListRelativeTimeProps {
    timestamp: string | null;
}

export const ItemListRelativeTime = ({ timestamp }: ItemListRelativeTimeProps) => {
    const [relativeTime, setRelativeTime] = React.useState<string>('');

    React.useEffect(() => {
        // timestamp가 없으면 타이머 설정하지 않음
        if (!timestamp) {
            setRelativeTime('');
            return;
        }

        // 시간 업데이트 함수
        const updateTime = () => {
            const time = helpers.formatRelativeTime(timestamp);
            // 1분 미만인 경우 (초 단위, "방금 전", "곧") "1분 미만"으로 표시
            if (time.includes('초 전') || time === '방금 전' || time === '곧') {
                setRelativeTime('1분 미만');
            } else {
                setRelativeTime(time);
            }
        };
        // 초기 설정
        updateTime();
        // 10초마다 업데이트
        const interval = setInterval(updateTime, 10000);
        return () => clearInterval(interval);
    }, [timestamp]);

    if (!timestamp) {
        return <span>-</span>;
    }

    return (
        <span title={helpers.getSimpleISO(timestamp)}>
            {relativeTime}
        </span>
    );
};
